export default "__VITE_ASSET__$_vXkcz7__"